import { SvgIcon, SvgIconProps } from '@mui/material';

const XLogoIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M18.901 1.5h3.35l-7.319 8.364L23.54 22.5h-6.74l-5.278-7.75L4.74 22.5H1.39l7.829-8.95L.98 1.5h6.91l4.77 7.084L18.901 1.5Zm-1.175 18.878h1.856L6.9 3.524H4.91l12.816 16.854Z"
    />
  </SvgIcon>
);

export default XLogoIcon;
